import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class BoldenQueryPipe {
    transform(value, args) {
        if (args) {
            const str = args;
            const re = new RegExp(str, 'g');
            value = value.replace(re, `<b>${args}</b>`);
        }
        else {
            return `<b>${value}</b>`;
        }
        return value;
    }
}
BoldenQueryPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BoldenQueryPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
BoldenQueryPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BoldenQueryPipe, name: "boldenQuery" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BoldenQueryPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'boldenQuery'
                }]
        }] });

class PascalCasePipe {
    constructor() {
        this.hasSpace = /\s/;
        this.hasSeparator = /(_|-|\.|:)/;
        this.hasCamel = /([a-z][A-Z]|[A-Z][a-z])/;
        this.separatorSplitter = /[\W_]+(.|$)/g;
        this.camelSplitter = /(.)([A-Z]+)/g;
    }
    transform(value) {
        return this.toPascalCase(value);
    }
    toPascalCase(value) {
        return this.toSpaceCase(value).replace(/(?:^|\s)(\w)/g, (_m, letter) => {
            return letter.toUpperCase();
        });
    }
    toSpaceCase(value) {
        return this.toNoCase(value)
            .replace(/[\W_]+(.|$)/g, (_m, match) => {
            return match ? ' ' + match : '';
        })
            .trim();
    }
    toNoCase(value) {
        if (this.hasSpace.test(value)) {
            return value.toLowerCase();
        }
        if (this.hasSeparator.test(value)) {
            return (this.unseparate(value) || value).toLowerCase();
        }
        if (this.hasCamel.test(value)) {
            return this.uncamelize(value).toLowerCase();
        }
        return value.toLowerCase();
    }
    unseparate(value) {
        return value.replace(this.separatorSplitter, (_m, next) => {
            return next ? ' ' + next : '';
        });
    }
    uncamelize(value) {
        return value.replace(this.camelSplitter, (_m, previous, uppers) => {
            return (previous +
                ' ' +
                uppers
                    .toLowerCase()
                    .split('')
                    .join(' '));
        });
    }
}
PascalCasePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PascalCasePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
PascalCasePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PascalCasePipe, name: "pascalCase" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PascalCasePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'pascalCase'
                }]
        }] });

class PipesModule {
}
PipesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PipesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PipesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PipesModule, declarations: [BoldenQueryPipe, PascalCasePipe], imports: [CommonModule], exports: [BoldenQueryPipe, PascalCasePipe] });
PipesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PipesModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PipesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [BoldenQueryPipe, PascalCasePipe],
                    exports: [BoldenQueryPipe, PascalCasePipe]
                }]
        }] });

export { BoldenQueryPipe, PascalCasePipe, PipesModule };
